exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.system-popup-view{background-color:#fff}.system-popup-view .system-popup-message{margin:18px 16px;font-size:14px;color:#4a4a4a;font-family:Open Sans,sans-serif;font-weight:600;letter-spacing:0;text-align:left;word-break:break-word}.system-popup-view .system-popup-message p{padding:0;margin:0}.system-popup-view .system-popup-message img,.system-popup-view .system-popup-message svg{position:absolute;pointer-events:auto}.system-popup-view .system-popup-message .help .version{font-style:italic;margin-bottom:8px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/SystemPopupView/SystemPopupView.scss
// module id = 1708
// module chunks = 0